const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { i18n: { formatText } } = require('core/i18n');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
// @ commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
// @ constants
const { COLLECTIVE_ID, NON_COLLECTIVE_ID } = require('constants/index');

class ContractInformation extends React.Component {
    componentDidMount() {
        const {
            component,
            contractWizard,
            getContractInformation,
            immProfile
        } = this.props;
        const isCollective = immProfile.get('isCollective');
        if (!contractWizard.get('information_step1') && component.cms_key) {
            if (component.checkForCollectiveUser) {
                this.fetchContractInformation(isCollective, component);
            } else {
                getContractInformation(component.cms_key);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { component, immProfile } = this.props;
        const isCollective = immProfile.get('isCollective')
        if (prevProps.immProfile.get('isCollective') !== isCollective && component.checkForCollectiveUser) {
            this.fetchContractInformation(isCollective, component);
        }
    }

    fetchContractInformation(isCollective, component){
        const locationIds = component.locationIds;
        const location =  isCollective ? locationIds[COLLECTIVE_ID] : locationIds[NON_COLLECTIVE_ID];
        this.props.getContractInformationWithPricing(location);
    }

    render() {
        const { component, contractWizard, immProfile } = this.props;
        const information = contractWizard.get('information_step1');
        let content;

        if (component.checkForCollectiveUser && immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else if (contractWizard.get('isFetchingStep1')) {
            content = <LoadingSection />;
        } else if (!contractWizard.get('information_step1')) {
            content = <EmptyState title={formatText('contractsView-emptyStateTitle')} primaryText={formatText('contractsView-emptyStateText')} iconType="nointernet-banking"/>;
        } else {
            content = <HTMLSafeInjector message={information} />;
        }

        return (
            <article className="contract-information">
                {content}
            </article>
        );
    }
}

ContractInformation.propTypes = {
    component: PropTypes.object.isRequired,
    contractWizard: PropTypes.object.isRequired,
    getContractInformation: PropTypes.func.isRequired,
    getContractInformationWithPricing: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired
};

module.exports = ContractInformation;
